module.exports = __webpack_public_path__ + "static/media/avatar.61b13a5e.svg";